export default "__VITE_ASSET__BMWn04Es__"